import network, { Method } from "./../NetworkManager/NetworkManager.js";
import {
	FORGOTPASSWORD,
	LOGIN,
	LOGOUT,
	REGISTER,
	SETPASSWORD,
	SOCIAL_LOGIN,
	VERIFY,
} from "./../Constants/PathConstant.js";
import { UserParameter } from "../Helper/APIParam.js";

class User {
	async login(param = UserParameter) {
		try {
			const [error, responseJson] = await network.networkCall({
				path: LOGIN,
				method: Method.POST,
				param: param.data,
				currency: param.currency,
				language: param.language,
			});
			if (error) {
				return error;
			} else {
				return responseJson;
			}
		} catch (error) {
			return error;
		}
	}
	async social_login(param = UserParameter) {
		try {
			const [error, responseJson] = await network.networkCall({
				path: SOCIAL_LOGIN,
				method: Method.POST,
				param: param.data,
				currency: param.currency,
				language: param.language,
			});
			if (error) {
				return error;
			} else {
				return responseJson;
			}
		} catch (error) {
			return error;
		}
	}
	async register(param = UserParameter) {
		try {
			const [error, responseJson] = await network.networkCall({
				path: REGISTER,
				method: Method.POST,
				param: param.data,
				currency: param.currency,
				language: param.language,
			});
			if (error) {
				return error;
			} else {
				return responseJson;
			}
		} catch (error) {
			return error;
		}
	}
	async verify(param = UserParameter) {
		try {
			const [error, responseJson] = await network.networkCall({
				path: VERIFY,
				method: Method.POST,
				param: param.data,
				currency: param.currency,
				language: param.language,
			});
			if (error) {
				return error;
			} else {
				return responseJson;
			}
		} catch (error) {
			return error;
		}
	}
	async resendOTP(param = UserParameter) {
		try {
			const [error, responseJson] = await network.networkCall({
				path: REGISTER,
				method: Method.POST,
				param: param.data,
			});
			if (error) {
				return error;
			} else {
				return responseJson;
			}
		} catch (error) {
			return error;
		}
	}
	async forgotPassword(param = UserParameter) {
		try {
			const [error, responseJson] = await network.networkCall({
				path: FORGOTPASSWORD,
				method: Method.POST,
				param: param.data,
			});
			if (error) {
				return error;
			} else {
				return responseJson;
			}
		} catch (error) {
			return error;
		}
	}
	async setPassword(param = UserParameter) {
		try {
			const [error, responseJson] = await network.networkCall({
				path: SETPASSWORD,
				method: Method.POST,
				param: param.data,
			});
			if (error) {
				return error;
			} else {
				return responseJson;
			}
		} catch (error) {
			return error;
		}
	}

	async logout(param = { data }) {
		try {
			const [error, responseJson] = await network.networkCall({
				path: LOGOUT,
				method: Method.POST,
				param: param.data,
			});
			if (error) {
				return error;
			} else {
				return responseJson;
			}
		} catch (error) {
			return error;
		}
	}
}
const user = new User();
export default user;
